// extracted by mini-css-extract-plugin
export var active = "_kg-e";
export var blink = "_kg-f";
export var dropDownSelector = "_kg-5";
export var dropDownWrapper = "_kg-4";
export var fakeCursor = "_kg-d";
export var fontSizeButton = "_kg-7";
export var formQuillEditor = "_kg-0";
export var pressed = "_kg-g";
export var qlBlank = "_kg-1";
export var textFormattingToolbar = "_kg-2";
export var textFormattingToolbarClosed = "_kg-3";
export var textFormattingToolbarInline = "_kg-6";
export var textToolbarOption = "_kg-8";
export var toolbarCell = "_kg-a";
export var toolbarCellCollapsed = "_kg-b";
export var toolbarOptionHitArea = "_kg-c";
export var toolbarOverflow = "_kg-9";